// extracted by mini-css-extract-plugin
export default {"wrap":"AccordionList_wrap__rV0uZ","heading":"AccordionList_heading__+9w2U"};